import { render } from "./ViewCandidatesList.vue?vue&type=template&id=8484d8f2&scoped=true"
import script from "./ViewCandidatesList.vue?vue&type=script&lang=js"
export * from "./ViewCandidatesList.vue?vue&type=script&lang=js"

import "./ViewCandidatesList.vue?vue&type=style&index=0&id=8484d8f2&scoped=true&lang=scss"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8484d8f2"]])

export default __exports__